import { PayloadAction, createSlice } from '@reduxjs/toolkit';

interface subscriptionplanState {
    isLoading: boolean;
    subscriptionplanList: any;
    totalSubscriptionPlan: number;
    subscriptionplanDetail: any;
    // for vendor
    totalVendorSubscriptionPlan: number;
    vendorSubscriptionplanList: any;
    vendorSubscriptionplanDetail: any;
}

const initialState: subscriptionplanState = {
    isLoading: false,
    subscriptionplanList: [],
    totalSubscriptionPlan: 0,
    subscriptionplanDetail: {},
    // for vendor
    vendorSubscriptionplanList: [],
    totalVendorSubscriptionPlan: 0,
    vendorSubscriptionplanDetail: {},
};

const subscriptionplanSlice = createSlice({
    name: 'subscriptionplanSlice',
    initialState,
    reducers: {
        // For Driver
        getAllsubscriptionplanInIt: state => {
            state.isLoading = true;
        },
        getAllsubscriptionplanSuccess: (state, action: PayloadAction<any>) => {
            const data = action.payload.data;
            state.isLoading = false;
            state.totalSubscriptionPlan = data.count;
            state.subscriptionplanList = [...data.list];
        },
        getAllsubscriptionplanError: state => {
            state.isLoading = false;
            state.subscriptionplanList = [];
            state.totalSubscriptionPlan = 0;
        },
        deletesubscriptionplanInit: state => {
            state.isLoading = true;
        },
        deletesubscriptionplanSuccess: state => {
            state.isLoading = false;
        },
        deletesubscriptionplanError: state => {
            state.isLoading = false;
        },
        addsubscriptionplanInIt: state => {
            state.isLoading = true;
        },
        addsubscriptionplanSuccess: state => {
            state.isLoading = false;
        },
        addsubscriptionplanError: state => {
            state.isLoading = false;
        },
        getsubscriptionplanByIdInIt: state => {
            state.isLoading = true;
        },
        getsubscriptionplanByIdSuccess: (state, action: PayloadAction<any>) => {
            state.isLoading = false;
            state.subscriptionplanDetail = { ...action.payload.data };
        },
        getsubscriptionplanByIdError: state => {
            state.isLoading = false;
        },


        updateDriverPlanStatusInit: state => {
			state.isLoading = true;
		},
		updateDriverPlanStatusSuccess: state => {
			// state.isLoading = true;
		},
		updateDriverPlanStatusError: state => {
			state.isLoading = false;
		},


        // for vendor
        getAllVendorsubscriptionplanInIt: state => {
            state.isLoading = true;
        },
        getAllVendorsubscriptionplanSuccess: (state, action: PayloadAction<any>) => {
            console.log(action.payload.data, '0987');
            
            const data = action.payload.data;
            state.isLoading = false;
            state.totalVendorSubscriptionPlan = data.count;
            state.vendorSubscriptionplanList = [...data.list];
        },
        getAllVendorsubscriptionplanError: state => {
            state.isLoading = false;
            state.vendorSubscriptionplanList = [];
            state.totalVendorSubscriptionPlan = 0;
        },
        deleteVendorsubscriptionplanInit: state => {
            state.isLoading = true;
        },
        deleteVendorsubscriptionplanSuccess: state => {
            state.isLoading = false;
        },
        deleteVendorsubscriptionplanError: state => {
            state.isLoading = false;
        },
        addVendorsubscriptionplanInIt: state => {
            state.isLoading = true;
        },
        addVendorsubscriptionplanSuccess: state => {
            state.isLoading = false;
        },
        addVendorsubscriptionplanError: state => {
            state.isLoading = false;
        },
        getVenorsubscriptionplanByIdInIt: state => {
            state.isLoading = true;
        },
        getVendorsubscriptionplanByIdSuccess: (state, action: PayloadAction<any>) => {
            state.isLoading = false;
            state.vendorSubscriptionplanDetail = { ...action.payload.data };
        },
        getVendorsubscriptionplanByIdError: state => {
            state.isLoading = false;
        },

        updateVendorPlanStatusInit: state => {
			state.isLoading = true;
		},
		updateVendorPlanStatusSuccess: state => {
			// state.isLoading = true;
		},
		updateVendorPlanStatusError: state => {
			state.isLoading = false;
		},
    }
});

export const {
    updateDriverPlanStatusInit,
    updateDriverPlanStatusSuccess,
    updateDriverPlanStatusError,
    updateVendorPlanStatusInit,
    updateVendorPlanStatusSuccess,
    updateVendorPlanStatusError,
    getsubscriptionplanByIdInIt,
    getsubscriptionplanByIdSuccess,
    getsubscriptionplanByIdError,
    addsubscriptionplanInIt,
    addsubscriptionplanSuccess,
    addsubscriptionplanError,
    getAllsubscriptionplanInIt,
    getAllsubscriptionplanSuccess,
    getAllsubscriptionplanError,
    deletesubscriptionplanInit,
    deletesubscriptionplanSuccess,
    deletesubscriptionplanError,

    getAllVendorsubscriptionplanInIt,
    getAllVendorsubscriptionplanSuccess,
    getAllVendorsubscriptionplanError,
    deleteVendorsubscriptionplanInit,
    deleteVendorsubscriptionplanSuccess,
    deleteVendorsubscriptionplanError,
    addVendorsubscriptionplanInIt,
    addVendorsubscriptionplanSuccess,
    addVendorsubscriptionplanError,
    getVenorsubscriptionplanByIdInIt,
    getVendorsubscriptionplanByIdSuccess,
    getVendorsubscriptionplanByIdError
} = subscriptionplanSlice.actions;

export default subscriptionplanSlice.reducer;
